import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { fetchstorecategories } from "../services/api"; // match the import path cityServiceSlice uses

export const loadStoreCategories = createAsyncThunk(
    "storeCategories/load",
    async (_, { rejectWithValue }) => {
        try {
            const res = await fetchstorecategories();
            return Array.isArray(res?.data) ? res.data : [];
        } catch (err) {
            return rejectWithValue(err?.message || "Couldn't load categories.");
        }
    },
    {
        // already loaded or in-flight -> skip
        condition: (_, { getState }) => {
            const s = getState().storeCategories;
            return !s.loading && s.items.length === 0;
        },
    }
);

const storeCategoriesSlice = createSlice({
    name: "storeCategories",
    initialState: { items: [], loading: false, error: null, selected: null },
    reducers: {
        setSelectedCategory: (state, action) => {
            state.selected = state.selected === action.payload ? null : action.payload;
        },
        resetStoreCategories: () => ({ items: [], loading: false, error: null, selected: null }),
    },
    extraReducers: (builder) => {
        builder
            .addCase(loadStoreCategories.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(loadStoreCategories.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload;
            })
            .addCase(loadStoreCategories.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export const { setSelectedCategory, resetStoreCategories } = storeCategoriesSlice.actions;
export default storeCategoriesSlice.reducer;